module.exports = __webpack_public_path__ + "static/S-Factor_Newsletter_June2020-0062198980e70953a29a5badc283ccd0.pdf";